<template>
  <div class="twoFloor">
    <div class="border-box" v-loading="loading && !listData.length" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading">
      <div class="twoFloor-head">
        <el-popover placement="bottom-start" width="358" v-model="visible" @hide="hide" @show="show">
          <div class="popover-box">
            <div class="group-title">流程类型</div>
            <div class="group">
              <div class="all-checkbox">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              </div>
              <el-checkbox-group v-model="TemplateIds" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in typeList" :label="item.value" :key="item.value">{{ item.title }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="group">
              <div class="group-title">审批状态</div>
              <el-radio-group v-model="listQuery.where.Status">
                <el-radio :label="null">全部</el-radio>
                <el-radio :label="1">审批中</el-radio>
                <el-radio :label="2">已通过</el-radio>
                <el-radio :label="4">已驳回</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="filter" :class="{ filterActive: visible }" slot="reference"><i class="el-icon-shaixuan1"></i> 筛选</div>
        </el-popover>
      </div>
      <div v-if="listData.length">
        <ul class="msg-list infinite-list" v-infinite-scroll="getList" :infinite-scroll-disabled="loading">
          <li v-for="(item, i) in listData" :key="i" @click="toggle(item)" :class="{ 'active-item': activeId == item.ID }">
            <div class="msg-item">
              <div class="msg-item-left">
                <i class="el-icon-dingdan"></i>
              </div>
              <div class="msg-item-right">
                <div class="msg-title">{{ item.Title }}({{ item.Code }})</div>
                <div class="msg-info">
                  <div class="msg-time">{{ $common.timesToTime(item.ApplyDateTime, true) }}</div>
                  <div :class="{ 'msg-state-pass': item.Status === 2, 'msg-state-rejected': item.Status === 4, 'msg-state-under': item.Status == 1 }">{{ item.Status == 2 ? '已通过' : item.Status == 4 ? '已驳回' : item.Status == 1 ? '审核中' : '' }}</div>
                </div>
              </div>
            </div>
          </li>
          <p v-if="loading" class="msg-list-load">加载中...</p>
          <p v-else class="msg-list-load">没有更多了</p>
        </ul>
      </div>
      <div class="empty" v-else>
        <img src="/static/picture/record-blank.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { WorkflowQuery } from '@/http/api';
import { fetchSysDicList } from '@/http/dictionary';
export default {
  name: 'twoFloor',
  props: ['userInfo', 'type', 'searchVal', 'isRefresh'],
  data() {
    return {
      listQuery: {
        where: {
          ApplyUserID: null, // userid
          CurrentOperatorId: null, // 当前处理人id
          HistoryOperatorId: null, // 历史处理人id
          TemplateIds: [],
          Title: '',
          Status: null,
          CopyToUserId: null,
        },
        pageNum: 1,
        pageSize: 20,
        order: 'ApplyDateTime desc',
      },
      oldListQuery: {},
      TemplateIds: [],
      listData: [],
      typeList: [],
      checkAll: false,
      isIndeterminate: false,
      activeId: null,
      visible: false,
      loading: false,
    };
  },
  watch: {
    type: {
      handler(val) {
        this.listData = [];
        this.activeId = null;
        this.listQuery = this.$options.data.call(this).listQuery;
        this.TemplateIds = this.$options.data.call(this).TemplateIds;
        this.isIndeterminate = this.$options.data.call(this).isIndeterminate;
        this.checkAll = this.$options.data.call(this).checkAll;
        for (let key in this.listQuery.where) {
          if (key == 'TemplateIds') {
            this.listQuery.where[key] = [];
          } else {
            this.listQuery.where[key] = null;
          }
        }
        switch (val) {
          case 1:
            if (this.userInfo.UserName != 'Admin') this.listQuery.where.ApplyUserID = this.userInfo.UserId;
            break;
          case 2:
            this.listQuery.where.CurrentOperatorId = this.userInfo.UserId;
            this.listQuery.where.Status = 1;
            break;
          case 3:
            this.listQuery.where.HistoryOperatorId = this.userInfo.UserId;
            this.listQuery.order = 'ModifyTime desc';
            break;
          case 4:
            this.listQuery.where.CopyToUserId = this.userInfo.UserId;
            break;
          default:
            break;
        }
        this.getList();
      },
      immediate: true,
    },
    TemplateIds(val, oldVal) {
      this.listQuery.where.TemplateIds = val;
    },
    searchVal(val = '', oldVal) {
      this.listQuery.where.Title = val;
      this.listQuery.pageNum = 1;
      this.listData = [];
      this.getList();
    },
    isRefresh(val, oldVal) {
      this.listQuery.pageNum = 1;
      this.listData = [];
      this.getList();
    },
  },
  created() {
    this.init();
  },
  methods: {
    getList() {
      this.loading = true;
      WorkflowQuery(this.listQuery, 'Page').then((res) => {
        if (Array.isArray(res.Data) && res.Data.length) {
          this.listData = [...this.listData, ...res.Data];
          this.listQuery.pageNum++;
        }
        this.loading = false;
      });
    },
    init() {
      fetchSysDicList('BasicData', 'AuditFlow').then((res) => {
        res.forEach((item) => {
          let title = item.Name == 3 ? '归档资料借阅流程' : item.Name == 4 ? '合作客户申请流程' : item.Name == 5 ? '重点客户申请流程' : item.Name == 6 ? '工作日志审批流程' : item.Name == 8 ? '中标跟进申请流程' : item.Name == 9 ? '渠道提成配置申请' : item.Name == 13 ? '费用报销申请流程' : item.Name == 14 ? '外部提成人申请' : item.Name == 15 ? '投标渠道成本和代垫退款申请' : item.Name == 16 ? '负责人折扣申请' : item.Name == 17 ? '渠道邀请码审批流程' : '';
          if (title) {
            this.typeList.push({
              label: item.Title,
              value: item.Name * 1,
              title,
            });
          }
        });
      });
    },
    toggle(item) {
      this.activeId = item.ID;
      this.$emit('push', item);
    },
    handleCheckAllChange(val) {
      const list = this.typeList.map((key) => key.value);
      this.TemplateIds = val ? list : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.typeList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.typeList.length;
    },
    show() {
      this.oldListQuery.TemplateIds = this.listQuery.where.TemplateIds;
      this.oldListQuery.Status = this.listQuery.where.Status;
    },
    hide() {
      let newStr = this.listQuery.where.TemplateIds.join(',');
      let oldStr = this.oldListQuery.TemplateIds.join(',');
      if (newStr == oldStr && this.listQuery.where.Status == this.oldListQuery.Status) return;
      this.listQuery.pageNum = 1;
      this.listData = [];
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
@import '../../../style/twoFloor.less';
</style>
